// Stato del canone dell'app, letto dalle risposte di crm-server (vedi boot/axios)
const HIDDEN_KEY = 'subscription_banner_hidden'

function readHidden() {
  try { return sessionStorage.getItem(HIDDEN_KEY) === '1' } catch { return false }
}

export default {
  namespaced: true,

  state: {
    status: null, // null | 'tolleranza'
    validUntil: null, // YYYY-MM-DD, ultimo giorno prima del blocco
    blockedMessage: null, // messaggio del 402 subscription_blocked
    hasSession: false, // false se il 402 arriva dal tentativo di login
    bannerHidden: readHidden(),
  },

  getters: {
    inGracePeriod: ({ status, validUntil }) => status === 'tolleranza' && Boolean(validUntil),
    blocked: ({ blockedMessage }) => blockedMessage !== null,
  },

  mutations: {
    setStatus(state, { status, validUntil }) {
      state.status = status || null
      state.validUntil = validUntil || null
    },
    setBlocked(state, { message, hasSession }) {
      state.blockedMessage = message
      state.hasSession = hasSession
    },
    hideBanner(state) {
      state.bannerHidden = true
      try { sessionStorage.setItem(HIDDEN_KEY, '1') } catch {}
    },
  },
}
